var App = App || {};

App.PrimaryNav = (function ($) {
    "use strict";

    var $primary,
        $toggle,
        $menu,
        _isOpenDesktop,
        $body;

    function init() {
        $primary = $("#PrimaryNav");
        $toggle = $primary.find(".primary-nav__toggle");
        $menu = $(".primary-nav__menu");
        $body = $('body');

        $toggle.on("click", toggleNav);

        _isOpenDesktop = false;

        $('.menu-promo-personalized').each(function () {
            if (!isEmpty($(this).find(".mega-menu-promos > .container > div"))) {
                var id = $(this).data("item-id");

                $('.menu-promo-default[data-item-id=' + id + ']').hide();
            }
        })

        $(document).bind("enter-md enter-sm enter-xs", function () {
            if (App.PrimaryNav.isOpenDesktop()) {
                closeNav();
                closeContent();
            }
        });

        App.Base.$window.on("keydown", function (e) {
            //if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
            //    e.preventDefault();
            //}

            //Escape
            if (_isOpenDesktop && e.keyCode === 27) {
                e.preventDefault();

                closeNav();
                closeContent();
            }
        });

        $(document).on('click', function (event) {
            if (_isOpenDesktop) {
                if (!$(event.target).closest($menu).length) {
                    closeNav();
                    closeContent();
                }
            }
        });

        $menu.find('.btn-close').on('click', function (event) {
            if (_isOpenDesktop) {
                closeNav();
                closeContent();
            }
        });


        //Hover
        $(".nav-tabs > .primary-nav__level-1-item-tab").each(function () {
            $(this).attr("tabindex", "0");
        });

        $(".nav-tabs > .primary-nav__level-1-item-tab").on("click", function () {
            $(this).tab("show");
            $(this).addClass("active");
            $(this).siblings(".tab-pane").tab("hide").removeClass("active");

            $(".nav-tabs > .primary-nav__level-1-item-tab").each(function () {
                $(this).attr("tabindex", "0");
            });

            if (!$(".tab-content").hasClass("tab-content--open")) {
                showContent();
            }
        });
    };

    function toggleNav() {
        _isOpenDesktop ? closeNav() : openNav();
    }


    function showContent() {
        $menu.addClass("tab-content--open")
        $menu.find(".tab-content")
            .addClass(".tab-content--open")
            .attr("aria-expanded", "true");

        $menu.find(".tab-content")
            .addClass("animate__animated animate__slideInRight")
            .show();
    }

    function closeContent() {
        $menu.removeClass("tab-content--open")
        $menu.find(".tab-content")
            .removeClass(".tab-content--open")
            .attr("aria-expanded", "false");

        $menu.find(".tab-content")
            .removeClass("animate__animated animate__slideInRight")
            .hide();
    }
    function openNav() {
        if (App.Login.isOpen()) {
            App.Login.closeLogin();
        }

        if (App.HamburgerNav.isOpenMobile()) {
            App.HamburgerNav.closeMenu();
        }

        $toggle
            .addClass("primary-nav__toggle--open")
            .attr("aria-expanded", "true");

        $menu
            .one("animationend", function () {
                _isOpenDesktop = true;
            })
            .addClass("animate__animated animate__slideInRight")
            .show();

        $menu.find(".tab-content")
            .one("animationend", function () {
                _isOpenDesktop = true;
            })
            .addClass("animate__animated animate__slideInRight")
            .show();

        $toggle.focus();

        lowerZindex();
    }

    function closeNav() {
        $toggle
            .removeClass("primary-nav__toggle--open")
            .attr("aria-expanded", "false");

        $menu
            .one("animationend", function () {
                $menu
                    .removeClass("animate__animated animate__slideOutRight")
                    .hide();
                $toggle.focus();
                _isOpenDesktop = false;
            })
            .removeClass("animate__slideInRight")
            .addClass("animate__slideOutRight");

        setTimeout(
            function () {
                higherZindex();
            }, 1200);
    };


    function lowerZindex() {
        $body.addClass('has-overlay nav-overlay');
        $("#site-header").css("z-index", "8");
        $(".site-header-layout").css("z-index", "8");
        $("#alerts").css("z-index", "8");
    }

    function higherZindex() {
        $body.removeClass('has-overlay nav-overlay');
        $("#site-header").css("z-index", "1202");
        $(".site-header-layout").css("z-index", "1202");
        $("#alerts").css("z-index", "1202");
    }

    function isEmpty(el) {
        return !$.trim(el.html())
    }

    return {
        init: init,
        closeNav: closeNav,
        isOpenDesktop: function () { return _isOpenDesktop; }
    };
})(jQuery);

$(function () {
    App.PrimaryNav.init();
});